import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';

const PaginaSucesso = () => {
    const { t } = useTranslation();
    return (
        <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
        }}
        >
        <CheckCircleOutlineIcon style={{ color: '#7cb342', fontSize: '60px' }} />
        <Typography
            variant="h5"
            sx={{
            marginTop: '16px',
            fontWeight: 'bold',
            }}
        >
            {t("main.sucesso")}
        </Typography>
        <Typography
            variant="body1"
            sx={{
            marginTop: '8px',
            }}
        >
            {t("main.sucesso-mensagem")}
        </Typography>
        </Box>
    );
};

export default PaginaSucesso;
